import { getProductStatus } from 'src/clients';
import { RootState } from '../reducers/rootReducer';
import { ACTION_TYPES } from '../types/productStatusTypes';

export const loadProductStatus = (isForceLoad = false) => {
  return {
    types: [
      ACTION_TYPES.LOAD_PRODUCT_STATUS_LIST,
      ACTION_TYPES.LOAD_PRODUCT_STATUS_LIST_SUCCESS,
      ACTION_TYPES.LOAD_PRODUCT_STATUS_LIST_FAILED,
    ],
    client: getProductStatus,
    shouldCallAPI: (state: RootState) =>
      isForceLoad ||
      (state.productStatus.data.length === 0 &&
        !state.productStatus.isFetching),
  };
};
